export default __webpack_public_path__ + "static/the-power-of-integration-with-tms-aaae0874eec1f0e75c28550f57a07511.png";